export async function initGamesJackpots() {
  const { getJackpotsJson, addJackpot } = await import('../../panels/jackpots');
  try {
    let jackpotData = await getJackpotsJson();
    jackpotData = Array.isArray(jackpotData) ? jackpotData : [];
    jackpotData = uniqueByGameId(jackpotData);

    for (const jackpot of jackpotData) {
      const gameElList = document.querySelectorAll(`.games-body .game[data-game-id="${jackpot.GameId}"]`);

      if (gameElList && gameElList.length > 0) {
        for (const gameEl of gameElList) {
          addJackpot(gameEl);
        }
      }
    }
  } catch (error) {
    console.error('Error initializing games jackpots:', error);
  }
}

function uniqueByGameId(data) {
  return Array.isArray(data)
    ? data.filter((item, index, array) => array.findIndex((x) => x.GameId === item.GameId) === index)
    : [];
}
